/**
 * Smooth open/close animation for <details> accordion elements.
 * Uses the CSS grid-template-rows trick for height transitions.
 */
(function () {
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.accordion summary');
    if (!summary) return;

    var details = summary.closest('details');
    if (!details) return;

    var wrapper = details.querySelector('.accordion__content-wrapper');
    if (!wrapper) return;

    if (details.open) {
      // Closing: animate first, then remove open attribute
      e.preventDefault();

      // Guard against double-click while already closing
      if (details.classList.contains('is-closing')) return;

      details.classList.add('is-closing');

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        details.classList.remove('is-closing');
        details.removeAttribute('open');
      }

      // Listen for the grid-template-rows transition specifically
      wrapper.addEventListener('transitionend', function handler(evt) {
        if (evt.target === wrapper && evt.propertyName === 'grid-template-rows') {
          wrapper.removeEventListener('transitionend', handler);
          finish();
        }
      });

      // Safety fallback — matches the CSS transition duration (350ms) + buffer
      setTimeout(finish, 400);
    } else {
      // Opening: clear any stale closing state
      details.classList.remove('is-closing');
    }
  });
})();
